import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  makeStyles,
  Typography,
} from '@material-ui/core';

import Close from '@material-ui/icons/Close';

import Selection from './components/Selection';

import styles from './styles';
import { clearInternalNewRequest } from 'app/store/slices/forms';
const useStyles = makeStyles(styles);

function InternalAddNewRequest(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [openNewRequest, setOpenNewRequest] = useState(false);

  const handleClose = () => {
    setOpenNewRequest(false);
    dispatch(clearInternalNewRequest());
  };

  return (
    <>
      <Drawer anchor="right" open={openNewRequest} onClose={handleClose}>
        <div className={classes.header}>
          <Typography variant="h5">Nova Solicitação</Typography>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <div className={classes.content}>
          <Container>
            <Selection {...props} setOpenNewRequest={setOpenNewRequest} />
          </Container>
        </div>
      </Drawer>
      <Box className={classes.boxBtnNew}>
        <Button
          variant="contained"
          color="secondary"
          disableElevation
          onClick={() => setOpenNewRequest(true)}
          className={classes.btnNew}
        >
          Novo
        </Button>
      </Box>
    </>
  );
}

export default InternalAddNewRequest;
